
export default {
  name: 'MessageCustom',
  props: {
    severity: {
      required: false,
      type: String,
      default: 'error',
    },
    icon: {
      required: false,
      type: String,
      default: 'pi-exclamation-circle',
    },
    onClose: {
      required: false,
      type: Function,
      default: null,
    },
  },
};
